module.exports = __webpack_public_path__ + "img/CM.cad2a970.png";